class Collection {
    services = [];
  
    constructor(ModelClass) {
      this.ModelClass = ModelClass;
    }
  
    isEmpty() {
      return this.services.length === 0;
    }
  
    get(id) {
      return this.services.find((model) => model.getId() === id);
    }
  
    getAll() {
      return [...this.services];
    }
  
    add(attrs = {}) {
      const model = attrs instanceof this.ModelClass ? attrs : new this.ModelClass(attrs);
      this.services.push(model);
      return model;
    }
  
    remove(model) {
      const index = this.services.indexOf(model);
      this.store.splice(index, 1);
    }
  
    empty() {
      this.services = [];
    }
  }
  
  export default Collection;
  